const styles = theme => ({
  tooltip: theme.mixins.gutters({
    margin: 0,
    lineHeight: '12px',
    border: '1px solid #f5f5f5',
    backgroundColor: 'rgba(255, 255, 255, 1)',
    padding: '0px',
    fontSize: '12px'
  }),
  label: {
    margin: 0,
    color: '#666',
    fontWeight: 700,
    paddingLeft: '0px',
    paddingRight: '0px'
  },
  value: {
    margin: 0,
    fontWeight: 200,
    paddingLeft: '0px',
    paddingRight: '0px'
  }

})

export default styles
